import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TagSchema = withDefaults({
  type: 'tag',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'taggable',
      type: 'taggable',
      options: {
        async: false,
        polymorphic: true,
        inverse: 'tags',
      },
    },
  ],
});

export default TagSchema;
